<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )

    template(slot="body")
      div(v-if="dadosVtn")
        div(v-if="!isEstadoAP")
          app-dados-calculo-vtn(:dadosVtn="dadosVtn" :tipoProcesso="tipoProcesso" :resumo="true" :visualizar="true")
          app-resumo-parcelas-vtn(:formaPagamento="dadosVtn.formaPagamento" :tipoProcesso="tipoProcesso")
        div(v-else)
          app-dados-calculo-vtn-AP(:dadosVtn="dadosVtn")
      div(v-if="exibirTituloOld")
        app-pdf-viewer-old(
          :bytes="bytes"
          v-if="bytes && isProcesso && arrayBytes && arrayBytes.length"
        )
      div(v-else)
        app-pdf-slider(
          v-if="bytes && isProcesso && arrayBytes && arrayBytes.length"
          :documentosBytes="arrayBytes"
          :documentos="despachos"
          @changePdfDownload="changePdfDownload"
        )
        app-pdf-viewer(
          :bytes="bytes"
          v-if="bytes && (!arrayBytes || !arrayBytes.length) && !isImagem"
        )
      app-image-viewer(
        :bytes="bytes"
        v-if="bytes && (!arrayBytes || !arrayBytes.length) && isImagem && visualizarDocumentosPDF "
      )

    template(slot="footer", v-if="!dadosVtn && !imprimir")
      div.flex
        el-button(@click="downloadPdf", v-if="!isImagem")
          i.fal.fa-file-pdf
          span &nbsp Exportar PDF
        el-button(@click="downloadPdf" v-if="isImagem")
          i.fal.fa-file-pdf
          span &nbsp Exportar Imagem
    template(slot="footer", v-if="imprimir")
      div.flex
        el-button(@click="imprimirPDF")
          i.fal.fa-print
          span &nbsp Imprimir

</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components/AppPDFViewer'
import AppPdfViewerOld from '@/components/AppPDFViewerOld'
import AppPdfSlider from '@/components/AppPDFSlider'
import axios from '@/utils/api'
import FileHelper from '@/utils/fileHelper'
import AppDadosCalculoVtn from '@/components/AppDadosCalculoVtn'
import AppDadosCalculoVtnAP from '@/components/AppDadosCalculoVtnAP'
import AppResumoParcelasVtn from '@/components/AppResumoParcelasVtn'
import AppImageViewer from '../../../components/AppImageViewer'
import { mapActions } from 'vuex'
import { stringToArrayBuffer } from '@/utils/utils'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppPdfViewer,
    AppPdfViewerOld,
    FileHelper,
    AppDadosCalculoVtn,
    AppResumoParcelasVtn,
    AppPdfSlider,
    AppImageViewer,
    AppDadosCalculoVtnAP
  },

  data () {
    return {
      bytes: null,
      dadosVtn: null,
      arrayBytes: [],
      despachos: [],
      despachoAtual: null,
      visualizarDocumentosPDF: false
    }
  },

  props: {
    width: {
      type: Number,
      default: window.innerWidth * 0.85
    },
    tipo: {
      type: String,
      default: null
    },
    titulo: {
      type: String,
      required: true
    },
    conteudo: {
      validator: function (value) {
        return typeof value === 'string' || typeof value === 'number'
      },
      required: true
    },
    conteudoSemId: {
      type: Object,
      required: false
    },
    isProcesso: {
      type: Boolean,
      default: false
    },
    isVTN: {
      type: Boolean,
      default: false
    },
    isImagem: {
      type: Boolean,
      default: false
    },
    tituloDocumento: {
      type: String,
      required: false
    },
    isNotId: {
      type: Boolean,
      default: false,
      required: false
    },
    imprimir: {
      type: Boolean,
      default: false
    },
    tipoProcesso: {
      type: String
    },
    isVisualisaProcessoDespacho: {
      type: Boolean
    },
    arrayBuffer: {
      required: false
    }
  },

  async mounted () {
    if (this.arrayBuffer) {
      this.bytes = this.arrayBuffer
    } else if (this.isVTN) {
      await this.getVtn()
    } else {
      let url = ''
      switch (this.tipo) {
        case 'TITULO_CERTIDAO':
          if (this.isProcesso) {
            const response = await this.getDespachosByProcessoETipo({
              tipo: 'TITULO_CERTIDAO',
              idProcesso: this.conteudo
            })
            this.despachos = response
            this.despachoAtual = this.despachos[0]
            const certidoes = await this.getArrayTituloByProcessoId(
              this.conteudo
            )
            this.arrayBytes = certidoes.map(certidao => ({
              id: certidao.id,
              bytes: stringToArrayBuffer(certidao.bytes)
            }))

            const lastTitulo = this.arrayBytes.reduce((max, current) => {
              return current.id > max.id ? current : max
            }, this.arrayBytes[0])

            this.bytes = lastTitulo.bytes
          } else {
            url = `despacho/pdf/titulo/${this.conteudo}`
          }
          break
        case 'ERRATA_TITULO':
          url = `despacho/pdf/retificacao/titulo/processo/${this.conteudo}`
          break
        case 'MINUTA_ERRATA':
          url = `despacho/pdf/retificacao/titulo/${this.conteudo}`
          break
        case 'PORTARIA':
          url = `despacho/pdf/portaria/${this.conteudo}`
          break
        case 'LAUDO_ANALISE_AUTOMATIZADA':
          url = `analiseAutomatizada/laudoPdfView/${this.conteudo}`
          break
        case 'RELATORIO_VISTORIA':
          url = `app/vistoria/pdfRelatorio/${this.conteudo}`
          break
        case 'PDF_DEPACHO_ASSINATURA':
          url = `publico/documentoAutenticavel/getDocumentoDespacho/${this.conteudo}`
          break
        case 'DOCUMENTO_AUTENTICAVEL':
          url = `documentoAutenticavel/pdfView/${this.conteudo}`
          break
        case 'DOCUMENTO_GABINETE':
          url = `despacho/pdf/documentoGabinete/${this.conteudo}`
          break
        case 'LAUDO_AUTOMATICO':
          url = `despacho/pdf/laudoAutomatico/${this.conteudo}`
          break
        case 'MAPA_PLANTA':
          url = `despacho/pdf/mapaPlanta/${this.conteudo}`
          break
        case 'OFICIO_CCR':
        case 'CANCELAMENTO_CLAUSULA_RESOLUTIVA':
          url = `despacho/pdf/oficio/processo/${this.conteudo}`
          break
        case 'DOCUMENTO':
          url = `documento/pdfView/${this.conteudo}`
          break
        case 'DOCUMENTO_ARRECADACAO':
          url = `arrecadacao/documentos/pdfView/${this.conteudo}`
          break
        case 'LAUDO_VALIDACAO':
          url = `analiseAutomatizada/laudoPdfView/${this.conteudo}/validacao`
          break
        case 'DOCUMENTO_MENSAGEM':
          url = `anexoMensagem/view/${this.conteudo}`
          break
        case 'EXTRATO_SENTENCA':
          if (this.isVisualisaProcessoDespacho) {
            url = `despacho/pdf/extratoSentenca/${this.conteudo}`
          } else {
            url = `despacho/pdf/extratoSentenca/${this.conteudo}/view`
          }
          break
        case 'CERTIDAO_AREA':
          url = `despacho/pdf/certidaoArea/${this.conteudo}`
          break
        default:
          break
      }
      if (this.tipo === 'DOCUMENTO_SEM_ID') {
        await axios({
          method: 'POST',
          url: `documento/file`,
          data: this.conteudoSemId,
          responseType: 'arraybuffer'
        }).then(res => {
          this.despachos = [res]
          this.despachoAtual = res
          this.bytes = res
          this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
        })
          .catch(e => {
            console.error(e)
          })
        return
      }
      if (this.tipo !== 'TITULO_CERTIDAO' || !this.isProcesso) {
        if (this.isNotId) {
          await axios({
            method: 'POST',
            url: `documento/pdfViewByCaminho`,
            data: {caminho: this.conteudo},
            responseType: 'arraybuffer'
          })
            .then(res => {
              this.despachos = [res]
              this.despachoAtual = res
              this.bytes = res
            })
            .catch(e => {
              console.error(e)
            })
        } else {
          await axios({
            method: 'get',
            url: url,
            responseType: 'arraybuffer'
          })
            .then(res => {
              this.despachos = [res]
              this.despachoAtual = res
              this.bytes = res
            })
            .catch(e => {
              console.error(e)
            })
        }
      }
    }
    this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
  },

  computed: {
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    },

    exibirTituloOld () {
      return this.isEstadoAP && this.tipo === 'TITULO_CERTIDAO'
    }
  },

  methods: {
    ...mapActions({
      getDespachosByProcessoETipo: 'despacho/findByFilter',
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId',
      getArrayRetificacaoTituloByDespachoId: 'despacho/getArrayRetificacaoTituloByDespachoId'
    }),
    async downloadPdf () {
      if (this.tipo === 'LAUDO_ANALISE_AUTOMATIZADA') {
        await axios({
          method: 'GET',
          url: 'analiseAutomatizada/laudoPdfDownload/' + this.conteudo,
          responseType: 'blob'
        })
      } else if (this.tituloDocumento != null) {
        FileHelper.saveFile(this.bytes, this.tituloDocumento)
      } else {
        FileHelper.saveFile(this.bytes, this.titulo)
      }
    },
    imprimirPDF () {
      //! TODO funcao feita para imprimir o pdf
      const blob = new Blob([this.bytes], { type: 'application/pdf' })
      const blobURL = URL.createObjectURL(blob)
      const printWindow = window.open(blobURL)
      printWindow.onload = () => {
        printWindow.print()
      }
    },
    async getVtn () {
      this.dadosVtn = await axios({
        method: 'GET',
        url: `financeiro/vtn/${this.conteudo}`
      })
      if (this.dadosVtn) {
        this.$store.commit('vtn/SET_VTN', this.dadosVtn)
        this.idVtn = this.dadosVtn.id
      }
    },
    changePdfDownload (documento) {
      this.bytes = documento.bytes
      this.despachoAtual = this.despachos.find(
        despacho => despacho.id === documento.id
      )
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppModalVisualizaPdf.vue